import keys from './compact-style-keys.json'
import semanticClasses from './compact-semantic-classes.json'

const semantic: Record<string, string> = semanticClasses
const alias = (token: string) => semantic[token] || token

const known = new Map(keys.map((key, index) => [key, 'hc' + index.toString(36)]))
const keep = (c: string) => /^(v3-|homepage-|lucide|group(?:\/|$)|peer(?:\/|$)|sr-only$|tabular$|rotprice$|pi-price$|recharts)/.test(c) || c.includes('v3-') || /^(?:[a-z]+:)*size-/.test(c)

/** Use an equivalent shared rule only for a compiled, known utility combination. */
export function compactClassName(value: string | undefined): string | undefined {
  if (!value) return value
  const tokens = value.trim().split(/\s+/)
  const utilities = tokens.filter(c => !keep(c)).join(' ')
  let hash = 2166136261
  for (let i = 0; i < utilities.length; i++) hash = Math.imul(hash ^ utilities.charCodeAt(i), 16777619)
  const key = (hash >>> 0).toString(36)
  return known.has(key)
    ? [...tokens.filter(keep).map(alias), known.get(key)].join(' ')
    : tokens.map(alias).join(' ')
}
